/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ParameterCombinationTableDto } from './ParameterCombinationTableDto';
import {
    instanceOfParameterCombinationTableDto,
    ParameterCombinationTableDtoFromJSON,
    ParameterCombinationTableDtoFromJSONTyped,
    ParameterCombinationTableDtoToJSON,
} from './ParameterCombinationTableDto';

/**
 * @type TaskItemAreaDtoCombinationTable
 * 
 * @export
 */
export type TaskItemAreaDtoCombinationTable = ParameterCombinationTableDto;


export function TaskItemAreaDtoCombinationTableFromJSON(json: any): TaskItemAreaDtoCombinationTable {
    return TaskItemAreaDtoCombinationTableFromJSONTyped(json, false);
}

export function TaskItemAreaDtoCombinationTableFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDtoCombinationTable {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ParameterCombinationTableDtoFromJSONTyped(json, true) };
    return  ParameterCombinationTableDtoFromJSONTyped(json, true);
}

export function TaskItemAreaDtoCombinationTableToJSON(value?: TaskItemAreaDtoCombinationTable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfParameterCombinationTableDto(value)) {
        return ParameterCombinationTableDtoToJSON(value as ParameterCombinationTableDto);
    }

    return {};
}

/**
 * Check if a given object implements the TaskItemAreaDtoCombinationTable interface.
 */
export function instanceOfTaskItemAreaDtoCombinationTable(value: any): value is TaskItemAreaDtoCombinationTable {
    if (instanceOfParameterCombinationTableDto(value)) return true;
    return false;
}

